import { ProviderFeatures } from './provider-features';

export const maxioProviderFeatures: ProviderFeatures = {
  actions: {
    cancel: {
      enabled: true,
      schedules: {
        immediate: false,
        'end-of-period': true,
      },
      unpauseOnCancel: false,
    },
    pause: {
      enabled: true,
      extendPeriodEnd: false,
      startDates: {
        'period-end': true,
        immediate: true,
      },
      durations: {
        period: true,
        date: false,
      },
    },
    changePrice: {
      enabled: true,
      schedules: {
        immediate: true,
        'end-of-period': false,
      },
      prorate: true,
    },
    applyCoupon: {
      enabled: true,
    },
    extendTrial: {
      enabled: false,
    },
  },
  controllers: {
    coupons: {
      enabled: true,
      create: false,
      import: true,
    },
    customers: {
      findByEmail: false,
    },
  },
  features: {
    metricsDashboard: false,
    customerProfile: false,
  },
};
